/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  // GK-HUB: support team_ids[] filter for team-scoped canned responses (by agent)
  get({ searchKey, teamIds } = {}) {
    const params = new URLSearchParams();
    if (searchKey) params.append('search', searchKey);
    if (teamIds && teamIds.length) {
      teamIds.forEach(id => params.append('team_id[]', id));
    } else if (teamIds) {
      // Empty array = agent has no teams, show only globals
      params.append('team_id[]', '');
    }
    const query = params.toString();
    const url = query ? `${this.url}?${query}` : this.url;
    return axios.get(url);
  }
}

export default new CannedResponse();
